<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-20 09:40:58
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-11-21 09:18:17
 * @FilePath: \miniproweb\src\views\Radar\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="myBody">
    <van-tabs v-model="active">
      <van-tab>
        <template #title>
          <van-icon name="column" />卫星云图
        </template>
        <div class="imgBox">
          <img
            src="http://www.cdsqxt.com.cn:10003/Files/Weather/SAT/Product/SAT_TRUE_COLOR/2023-11-20/SEVP_NSMC_WXBL_FY4A_ETCC_ACHN_LNO_PY_20231120023800000.JPG"
            alt
            srcset
            style="width:100%;"
          />
        </div>
        <div class="controllerBox">
          <div class="PlayBtnBox">
            <div class="PlayBtnBoxItem">
              <van-icon name="arrow-left" size="30" color="#309AF8" />
            </div>
            <div class="PlayBtnBoxItem" @click="toPlay">
              <van-icon name="play" size="30" color="#309AF8" v-show="!isPaly" />
              <van-icon name="pause" size="30" color="#309AF8" v-show="isPaly" />
            </div>
            <div class="PlayBtnBoxItem">
              <van-icon name="arrow" size="30" color="#309AF8" />
            </div>
          </div>
          <div class="sildeBox">
            <van-slider
              v-model="value"
              bar-height="4px"
              active-color="#309AF8"
              inactive-color="#DDDDDD"
              :min="0"
              :max="10"
            >
              <template #button>
                <div class="custom-button"></div>
              </template>
            </van-slider>
          </div>
        </div>
      </van-tab>
      <van-tab title="雷达拼图">
        <template #title>
          <van-icon name="photo-fail" />雷达拼图
        </template>
        <div class="imgBox"></div>
        <div class="controllerBox">
          <div class="PlayBtnBox">
            <div class="PlayBtnBoxItem">
              <van-icon name="arrow-left" size="30" color="#309AF8" />
            </div>
            <div class="PlayBtnBoxItem">
              <van-icon name="play" size="30" color="#309AF8" />
            </div>
            <div class="PlayBtnBoxItem">
              <van-icon name="arrow" size="30" color="#309AF8" />
            </div>
          </div>
          <div class="sildeBox">
            <van-slider
              v-model="value"
              bar-height="4px"
              active-color="#309AF8"
              inactive-color="#9ad0ff"
            ></van-slider>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: "1",
      value: 0,
      isPaly: false,
      palyTimer: null
    };
  },
  methods: {
    toPlay() {
      this.isPaly = !this.isPaly;
      if (this.isPaly) {
        this.PlayHander();
      } else {
        clearInterval(this.palyTimer);
      }
    },
    PlayHander() {
      this.palyTimer = setInterval(() => {
        if (this.value <= 9) {
          this.value = this.value + 1;
        } else {
          this.value = 0;
        }
      }, 1000);
    }
  }
};
</script>

<style>
.myBody {
  height: 100vh;
  width: 100vw;
  padding: 5px 5px;
  background-color: #d3e7fe;
}
.imgBox {
  height: 500px;
  width: 95%;
  margin: auto;
  background-color: rgb(255, 255, 255);
  margin-top: 15px;
}

.controllerBox {
  height: 80px;
  width: 100%;
  margin-top: 15px;
  padding: 0 5px;
  border-radius: 5px;
  /* background-color: aqua; */
  /* position: fixed;
  bottom: 50px; */
  display: flex;
  justify-content: space-between;
  background-color: white;
}
.PlayBtnBox {
  height: 100%;
  width: 30%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* background-color: antiquewhite; */
}
.sildeBox {
  height: 100%;
  width: 65%;
  display: flex;
  align-items: center;
  /* background-color: #9ad0ff; */
}
.custom-button {
  width: 20px;
  height: 20px;
  border-radius: 15px;
  color: black;
  line-height: 20px;
  text-align: center;
  border: 3px solid #309af8;
  background-color: white;
}
</style>